/* eslint-disable */
import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';

import {
  getLocalStorage,
  removeItemLocalStorage,
  setLocalStorage,
} from './storage';

import { refreshTokenChatbotService } from 'services/accountConversations';
import { LOCAL_STORAGE_CHATBOT, ROUTE_PATHS } from 'utils/constants';

const axiosChatbotInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

axiosChatbotInstance.interceptors.request.use(
  ($config: AxiosRequestConfig): AxiosRequestConfig => {
    if ($config.headers) {
       const botId = (window as any).currentBotPath;
      const botKey = getLocalStorage(LOCAL_STORAGE_CHATBOT.BOTKEY + botId);

      const accessTokenChatBot = getLocalStorage(
        LOCAL_STORAGE_CHATBOT.ACCESSTOKEN_CHATBOT + botId,
      );
      if (accessTokenChatBot) {
        $config.headers.Authorization = `Bearer ${accessTokenChatBot}`;
      }
      if (botKey) {
        $config.headers['X-Bot-Key'] = botKey;
      }
      $config.headers['Content-Type'] = 'application/json';
      $config.headers.Accept = 'application/json';
    }
    return $config;
  },
  async (error: AxiosError): Promise<AxiosError> => Promise.reject(error),
);

let retry = false;

axiosChatbotInstance.interceptors.response.use(
  (response: AxiosResponse): AxiosResponse => response,
  async (error: AxiosError) => {
    const originalRequest = error.config;
    if (error.response?.status === 401 && !retry) {
      retry = true;
      const botId = (window as any).currentBotPath;
      try {
        const responseRefreshToken = await refreshTokenChatbotService();
   
        setLocalStorage(
          LOCAL_STORAGE_CHATBOT.ACCESSTOKEN_CHATBOT + botId,
          responseRefreshToken.accessToken,
        );
        setLocalStorage(
          LOCAL_STORAGE_CHATBOT.REFRESHTOKEN_CHATBOT,
          responseRefreshToken.refreshToken,
        );
        if (originalRequest && originalRequest.headers) {
          originalRequest.headers.Authorization = `Bearer ${responseRefreshToken.accessToken}`;
        }
        return await axiosChatbotInstance(originalRequest);
      } catch (err) {
        removeItemLocalStorage(LOCAL_STORAGE_CHATBOT.ACCESSTOKEN_CHATBOT + botId);
        removeItemLocalStorage(LOCAL_STORAGE_CHATBOT.REFRESHTOKEN_CHATBOT);
        removeItemLocalStorage(LOCAL_STORAGE_CHATBOT.CONVERSATION_CODE);
        removeItemLocalStorage(LOCAL_STORAGE_CHATBOT.ROLE + botId);
        removeItemLocalStorage(LOCAL_STORAGE_CHATBOT.VERIFIED  + botId);
        window.location.href = ROUTE_PATHS.CHATBOT_WIDGET;
        return await Promise.reject(err);
      } finally {
        retry = false;
      }
    }

    return Promise.reject(
      error.response && error.response.status === 422
        ? (error.response.data as any).errors
        : error,
    );
  },
);
export default axiosChatbotInstance;
